import React, { useState, useRef, useEffect } from "react";
import {
  IconLayoutKanban,
  IconList,
  IconChartBar,
  IconBolt,
  IconFilter,
  IconPlus,
  IconDownload,
  IconUpload,
  IconRefresh,
} from "@tabler/icons-react";
import { useCRM } from "../CRMContext";
import PipelineSelector from "./PipelineSelector";
import SearchBar from "./SearchBar";
import { exportContacts, importContacts } from "../services/contacts.service";

const CRMHeader = ({ onNewContact, onManagePipelines }) => {
  const { state, setViewMode, toggleFilterPanel, showToast, refreshBoard, loadPipelines } = useCRM();
  const [exportMenuOpen, setExportMenuOpen] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const exportRef = useRef(null);
  const fileInputRef = useRef(null);

  const handleRefresh = async () => {
    if (refreshing) return;
    setRefreshing(true);
    try {
      await loadPipelines();
      await refreshBoard();
      showToast("Dados atualizados!");
    } catch {
      showToast("Erro ao atualizar dados.", "error");
    } finally {
      setRefreshing(false);
    }
  };

  useEffect(() => {
    const handleClick = (e) => {
      if (exportRef.current && !exportRef.current.contains(e.target)) setExportMenuOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const handleExport = async () => {
    setExportMenuOpen(false);
    try {
      const filters = { ...state.filters };
      if (state.activePipelineId) filters.pipeline = state.activePipelineId;
      await exportContacts(filters);
      showToast("Contatos exportados com sucesso!");
    } catch {
      showToast("Erro ao exportar contatos.", "error");
    }
  };

  const handleImport = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setExportMenuOpen(false);
    try {
      const firstCol = state.columns[0];
      await importContacts(file, state.activePipelineId, firstCol?.id);
      showToast("Importação iniciada! Você será notificado quando estiver pronta.");
      refreshBoard();
    } catch {
      showToast("Erro ao importar contatos.", "error");
    }
    e.target.value = "";
  };

  const viewModes = [
    { key: "board", icon: IconLayoutKanban, label: "Kanban" },
    { key: "list", icon: IconList, label: "Lista" },
    { key: "dashboard", icon: IconChartBar, label: "Dashboard" },
    { key: "automations", icon: IconBolt, label: "Automações" },
  ];

  const activeFilterCount = Object.keys(state.filters).filter((k) => state.filters[k] !== undefined && state.filters[k] !== null && state.filters[k] !== "").length;

  return (
    <div className="crm-header">
      <div className="crm-header__left">
        <PipelineSelector onManage={onManagePipelines} />

        <div className="crm-view-toggle">
          {viewModes.map(({ key, icon: Icon, label }) => (
            <button
              key={key}
              className={`crm-view-toggle__btn ${state.viewMode === key ? "crm-view-toggle__btn--active" : ""}`}
              onClick={() => setViewMode(key)}
              title={label}
            >
              <Icon size={18} />
            </button>
          ))}
        </div>
      </div>

      <div className="crm-header__center">
        <SearchBar />
      </div>

      <div className="crm-header__right">
        <button
          className="crm-btn crm-btn--icon"
          onClick={handleRefresh}
          disabled={refreshing}
          title="Atualizar pipelines e contatos"
        >
          <IconRefresh
            size={18}
            style={refreshing ? { animation: "spin 1s linear infinite" } : undefined}
          />
        </button>

        <button className="crm-btn" onClick={toggleFilterPanel}>
          <IconFilter size={16} />
          Filtros
          {activeFilterCount > 0 && (
            <span className="crm-column__count">{activeFilterCount}</span>
          )}
        </button>

        <button className="crm-btn crm-btn--primary" onClick={onNewContact}>
          <IconPlus size={16} />
          Novo Contato
        </button>
        <div style={{ position: "relative" }} ref={exportRef}>
          <button className="crm-btn crm-btn--icon" onClick={() => setExportMenuOpen(!exportMenuOpen)} title="Exportar/Importar">
            <IconDownload size={18} />
          </button>
          {exportMenuOpen && (
            <div className="crm-dropdown">
              <button className="crm-dropdown__item" onClick={handleExport}>
                <IconDownload size={16} />
                Exportar CSV
              </button>
              {/* <button className="crm-dropdown__item" onClick={() => fileInputRef.current?.click()}>
                <IconUpload size={16} />
                Importar CSV
              </button> */}
            </div>
          )}
          <input
            ref={fileInputRef}
            type="file"
            accept=".csv"
            style={{ display: "none" }}
            onChange={handleImport}
          />
        </div>
      </div>
    </div>
  );
};

export default CRMHeader;
